import React, { useState } from "react";
import Employ from "../assest/employ.png";
import Footer from "./footer";
import FAQSection from "../utils/fnqaccordion";
import BookMeetingModal from "../utils/bookingmodal";
const ContactPage = () => {
  const [openModal, setOpenModal] = useState(false);
  return (
    <div className="bg-[#eee9f4]  mt-10 font-[Poppins]">
      {/* TOP BANNER */}
      <div
        className="h-[120px] bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1600585154340-be6161a56a0c')",
        }}
      ></div>

      {/* CONTACT SECTION */}
      <section className="bg-[#e6dff1] py-16 px-5">
        <div className="max-w-[1100px] mx-auto flex flex-col md:flex-row items-center justify-between gap-10">
          {/* LEFT */}
          <div className="flex-1 text-center md:text-left">
            <h2 className="text-2xl md:text-3xl font-[Newsreader] mb-3">
              Get in touch with us
            </h2>

            <p className="text-sm text-gray-600 mb-6 max-w-xl mx-auto">
              If you have questions or need assistance, we’re here to help.
              Contact us today and our team will provide the support you need.
            </p>

            <div className="mb-4">
              <p className="text-sm">Call Us</p>
              <p className="text-[#6a00ff] font-bold text-xl md:text-2xl">
                9999999999
              </p>
            </div>

            <div className="mb-6">
              <p className="text-sm">Email Us</p>
              <p className="text-[#6a00ff]">contact@toranaconstructions.com</p>
            </div>

            <button
              onClick={() => setOpenModal(true)}
              className="px-6 py-2 bg-[#6c4ccf] text-white rounded-md"
            >
              Book a meeting
            </button>
          </div>

          {/* RIGHT IMAGE */}
          <div className="flex-1 flex justify-center">
            <div className="w-[240px] h-[240px] md:w-[320px] md:h-[320px] bg-[#e2d3f6] rounded-full flex items-end justify-center relative">
              <img
                src={Employ}
                alt="worker"
                className="absolute bottom-0 w-[260px] md:w-[420px]"
              />
            </div>
          </div>
        </div>
      </section>

      {/* FAQ SECTION */}
      <section className="bg-[#e5d8f7] py-16 px-5">
        <h2 className="text-center text-xl font-semibold mb-10">
          Frequently asked questions
        </h2>
        {/* <div className="max-w-[1100px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-5">
          {Array(8)
            .fill("")
            .map((_, i) => (
              <div
                key={i}
                className="flex justify-between items-center border-b border-gray-300 py-3 text-sm"
              >
                <p>
                  Since how long has JSV been in the construction business?
                </p>
                <span className="text-lg font-bold">+</span>
              </div>
            ))}
        </div> */}
        .
        <FAQSection />
      </section>

      {/* FORM SECTION */}
      <section className="py-16 px-5 text-center">
        <h3 className="text-xl font-semibold">Any queries?</h3>

        <p className="text-sm text-gray-600 mb-6 max-w-xl mx-auto">
          If you have questions or need assistance, we're here to help. Contact
          us today and our team will provide the support you need.
        </p>

        <div className="bg-white p-6 rounded-lg max-w-md mx-auto shadow">
          <form className="space-y-3">
            {/* ROW */}
            <div className="flex flex-col md:flex-row gap-3">
              <input
                type="text"
                placeholder="Full name"
                className="w-full border p-2 rounded"
              />
              <input
                type="text"
                placeholder="Enter your number"
                className="w-full border p-2 rounded"
              />
            </div>

            <input
              type="email"
              placeholder="Email"
              className="w-full border p-2 rounded"
            />

            <textarea
              placeholder="Your message"
              className="w-full border p-2 rounded h-20"
            ></textarea>

            <label className="flex items-center gap-2 text-sm">
              <input type="checkbox" />I agree to receive communication.
            </label>

            <button type="submit" className="bg-gray-200 px-4 py-2 rounded">
              Send Enquiry
            </button>
          </form>
        </div>
      </section>
      {/* Book meeting  */}
      <section className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#d7c8f2] via-[#c5b7ea] to-[#e5b5d6] px-4 py-10">
        <div className="max-w-[900px] w-full text-center">
          {/* TITLE */}
          <h2 className="text-[24px] md:text-[28px] font-semibold">
            You Dream. We Deliver.
          </h2>

          <p className="text-gray-600 text-[13px] md:text-[14px] mt-2 mb-8">
            Ready to build your dream home? Schedule a free consultation to
            start your journey today.
          </p>

          {/* CARD */}
          <div className="bg-[#f3f3f3] p-6 md:p-8 rounded-xl shadow-sm">
            <form className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* INPUTS */}
              <input
                type="text"
                placeholder="Full Name"
                className="w-full px-3 py-3 rounded-lg border border-gray-300 text-sm outline-none focus:ring-2 focus:ring-purple-400"
              />

              <input
                type="email"
                placeholder="Email"
                className="w-full px-3 py-3 rounded-lg border border-gray-300 text-sm outline-none focus:ring-2 focus:ring-purple-400"
              />

              <input
                type="tel"
                placeholder="Mobile Number"
                className="w-full px-3 py-3 rounded-lg border border-gray-300 text-sm outline-none focus:ring-2 focus:ring-purple-400"
              />

              <select className="w-full px-3 py-3 rounded-lg border border-gray-300 text-sm outline-none focus:ring-2 focus:ring-purple-400">
                <option>Choose City</option>
                <option>Bhubaneswar</option>
                <option>Cuttack</option>
                <option>Delhi</option>
              </select>

              {/* FLOATING LABEL FIELD */}
              <div className="relative md:col-span-1">
                <label className="absolute -top-2 left-3 bg-[#f3f3f3] px-1 text-[11px] text-gray-500">
                  I want to start conversation in
                </label>

                <select className="w-full px-3 py-3 rounded-lg border border-gray-300 text-sm outline-none focus:ring-2 focus:ring-purple-400">
                  <option>0-3 months</option>
                  <option>3-6 months</option>
                  <option>6-12 months</option>
                </select>
              </div>

              {/* RADIO */}
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-3 text-sm">
                <p>Do you own a plot or land?</p>

                <div className="flex gap-4">
                  <label className="flex items-center gap-2">
                    <input type="radio" name="land" />
                    Yes
                  </label>

                  <label className="flex items-center gap-2">
                    <input type="radio" name="land" />
                    No
                  </label>
                </div>
              </div>

              {/* CHECKBOX */}
              <div className="flex items-start gap-2 md:col-span-2 text-[12px] text-gray-600">
                <input type="checkbox" className="mt-1" />
                <p>
                  I agree to{" "}
                  <span className="text-purple-600 cursor-pointer">
                    Privacy Policy
                  </span>{" "}
                  and{" "}
                  <span className="text-purple-600 cursor-pointer">
                    Terms & Conditions
                  </span>
                </p>
              </div>

              {/* BUTTON */}
              <button className="md:col-span-2 w-full py-3 rounded-lg text-white text-sm font-medium bg-gradient-to-r from-purple-300 to-purple-500 hover:opacity-90 transition">
                Book a meeting
              </button>
            </form>
          </div>
        </div>
      </section>
      <Footer />
      <BookMeetingModal openModal={openModal} setOpenModal={setOpenModal} />
    </div>
  );
};

export default ContactPage;
